import { apiClient } from "./client";

// Public settings endpoint — no auth required. Returns:
// { platform_name, price_per_county, price_all_types, maintenance_mode }
export const getSettings = () =>
  apiClient.get("/admin-settings/").then((r) => r.data);
